var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-modal',{attrs:{"modal-id":_vm.modalId,"title":_vm.title,"action-primary":_vm.$options.reload,"action-cancel":_vm.$options.cancel,"aria-live":"assertive"},on:{"primary":_vm.goTo},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_vm._v("\n  "+_vm._s(_vm.message)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }